import React, { Component } from 'react';
import { ReactComponent as Add } from 'assets/images/svg/Frame (21).svg';
import AddUser from 'Container/AppAccessControl/AddUserContainer';
import UsersGrid from './UsersGrid';
import formUrlParams from 'Helpers/urlform';
import Switch from './Switch';
import RefreshIcon from 'Components/Common/RefreshIcon';
import { formatSortForUrl } from 'Helpers';
import { DEFAULT_PAGE_LIMIT } from 'Components/Table/dataTable';
import { ModuleActions, Modules } from 'Constants/Modules.constants';
import Import from './Import';
import DownloadSampleCsv from './Import/DownloadSampleCsv';
import Export from './Export';

export default class Users extends Component{
    constructor(props){
        super(props);

        this.state = {
            addUserPopup: false,
            filtered: [],
            activeSort: {},
            pageLimit: DEFAULT_PAGE_LIMIT,
            refreshGridTime: new Date().getTime()
        }

        props.getAppAccessControlSwitchAction();
        props.fetchAppAccessControlUsers();
    }

    /**
     * @method hanldeAddAdmin
     * @summary open admin popup based click event
     * @return {none} undefined
     */

    toggleAddUserPopup = (addUserPopup) => {
        addUserPopup = typeof addUserPopup != 'undefined' ? addUserPopup : !this.state.addUserPopup;
        console.log('addUserPopup -- ', addUserPopup);
        this.setState({ addUserPopup }, () => {
            if(this.state.addUserPopup){
                document.getElementById('appAccessControlAddUser').classList.add('open');
            }
        });
    };

    /**
     * @method formUrlParams
     * @param {name} name - Query string name
     * @param {value} value - Query string value
     * @param {rest} rest - Rest object except name and value
     * @summary Construct the query string based on user selection
     * @return {function} call fetch admin roles  api after change local state
    */

    formUrlParams = (name, value, rest) => {
        const { filtered, activeSort } = this.state;
        const filterResponse = formUrlParams(filtered, name, value);
        this.setState({ filtered: filterResponse, ...rest }, () => {
        let updatedFilter = this.state.filtered;
        if(activeSort.orderBy && activeSort.sortBy){
            updatedFilter = [
            ...this.state.filtered,
            ...formatSortForUrl(activeSort)
            ]
        }
        this.props.fetchAppAccessControlUsers(updatedFilter);
        });
    };

    /**
     * @method sortTable
     * @summary sort for view data
     * @param {name} sortAttribite - Query string name
     * @return { function } formUrlSort
    */
    sortTable = (sortAttribite, columnName) => {
        const { activeSort } = this.state
        const sortType = activeSort.sortBy === columnName ? ((activeSort.orderBy && activeSort.orderBy == 'desc') ? 'asc' : 'desc') : 'asc';
        this.setState({
        activeSort: { sortBy: columnName, orderBy: sortType },
        }, () => {
            const updatedFilter = [
                ...this.state.filtered,
                ...formatSortForUrl(this.state.activeSort)
            ]
            this.props.fetchAppAccessControlUsers(updatedFilter);
        })
    }

    refreshGrid = () => {
        this.setState({
            filtered: [],
            activeSort: {},
            refreshGridTime: new Date().getTime(),
            pageLimit: DEFAULT_PAGE_LIMIT
        }, () => {
            this.props.fetchAppAccessControlUsers();
        })
    }

    render(){
        const filteredWithSort = [
            ...this.state.filtered,
            ...formatSortForUrl(this.state.activeSort)
        ];
        const { permissions, aacDownloadSampleCsvAction, aacExportUsersAction } = this.props;
        const permission = permissions?.[ Modules.appAccessControl ];
        return (<>
            <div className='grid pageContainer_inner'>
                <div className='heading-block gap-10'>
                    <div className='block_flex'>
                        <h4 className='m-right-initial'> App Access Control </h4>
                        <Switch permission = { permission } />
                    </div>
                    <div className='block_flex'>
                        { !permission?.[ ModuleActions.delete ] && <RefreshIcon dispatchFunction={ this.refreshGrid } /> }
                        { permission?.[ ModuleActions.import ] && <Import { ...this.props } filteredWithSort={ filteredWithSort } /> }
                        { permission?.[ ModuleActions.export ] && <Export aacExportUsersAction={ aacExportUsersAction } filteredWithSort={ filteredWithSort } /> }
                        { permission?.[ ModuleActions.import ] && <DownloadSampleCsv aacDownloadSampleCsvAction={ aacDownloadSampleCsvAction } /> }
                        { permission?.[ ModuleActions.add ] && <button className='btn btn_primary'  onClick={ () => this.toggleAddUserPopup() }>
                            <Add />
                            Add User
                        </button> }
                        {this.state.addUserPopup && (
                            <AddUser
                                addUserPopup={ this.state.addUserPopup }
                                toggleAddUserPopup={ this.toggleAddUserPopup }
                                filteredWithSort={ filteredWithSort }
                            />
                        )}
                    </div>
                </div>
                <div className='responsive-table ctTableBox'>
                    <UsersGrid 
                        { ...this.props }
                        formUrlParams={ this.formUrlParams }
                        sortTable= { this.sortTable }
                        refreshGrid={ this.refreshGrid }
                        pageLimit={ this.state.pageLimit }
                        filteredWithSort={ filteredWithSort }
                        refreshGridTime={ this.state.refreshGridTime }
                        appAccessControlDeleteUserAction={ this.props.appAccessControlDeleteUserAction }
                        appAccessControlDeleteUser={ this.props.appAccessControlDeleteUser }
                        permission = { permission }
                        activeSort={ this.state.activeSort }
                    />
                </div>
            </div>
            </>
        )
    }
}
